import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "../styles/Demo.css";
import { MenuUnfoldOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import GridViewIcon from "@mui/icons-material/GridView";
import {
  Button,
  Layout,
  Menu,
  ConfigProvider,
  theme,
  Drawer,
  Popconfirm,
} from "antd";
import PayService from "../pages/PayService/PayService";
import BBPS from "../components/BBPS/BBPSServices";
import PaymentLinks from "../pages/PaymentLinks/PaymentLinks";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SearchIcon from "@mui/icons-material/Search";
import Footer from "../components/Footer/Footer";
import { useLocation } from "react-router-dom";
import {
  clearDetailsToSend,
  setDetailsToSend,
} from "../redux/slice/detailsToSendSlice";
import SettlementsNew from "../pages/SettlementsNew/SettlementsNew";
import useUserData from "../Common/updateUser/updateUser";
import { ImagesPath } from "../Common/imagespath/imagespath";
import { setFeatures } from "../redux/slice/activeFeaturesSlice";
import { isFeatureActive } from "../Common/serviceActiveCheck/serviceActiveCheck";
import axios from "axios";
import Loaders from "./ReusebleComponents/Loaders";
import { data } from "../Common/Text/NormalText";
import {
  getUserDetailsByToken,
  GetWebAccessToken,
} from "./ReusebleComponents/ResuseableApiCalls";
import Call_Api from "../Common/Handileapi/Call_api";
import { path } from "../routes/Paths";

const { Header, Sider, Content } = Layout;

const Demo = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userName, getUserDetails } = useUserData();
  const userDetails = useSelector((state) => state?.user?.user);
  const [collapsed, setCollapsed] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [phNo, setPhNo] = useState("");
  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("selectedMenu") || "dashboard";
  });
  const [selectedMenuTitle, setSelectedMenuTitle] = useState(() => {
    return localStorage.getItem("selectedMenuTitle") || "Dashboard";
  });
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [showSearchProfile, setShowSearchProfile] = useState(false);
  const features = useSelector((state) => state.activeFeatures.features);
  const [searchText, setSearchText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [menuKey, setMenuKey] = useState(0);
  const [activeFeaturesLoading, setActiveFeaturesLoading] = useState(true);
  const [userImage, setUserImage] = useState("");
  const [activeFeatures, setActiveFeatures] = useState([]);
  const hiddenFooterPaths = [
    "/PaymentLinks",
    "/History",
    "/Dashboardpage",
    "/Settlement",
    "/SettlementDetails",
    "/Analytics",
    "/Users",
    "/Payouts",
  ];
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const isHomeRoute = location.pathname;
  const token = Cookies.get("token");
  const isAuthenticated = !!token;

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
      setCollapsed(true);
    } else {
      setIsMobile(false);
      setCollapsed(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  useEffect(() => {
    const path =
      window.location.pathname.substring(1)?.split("/")?.[1] || "Dashboardpage";
    // setSelectedMenu(localStorage.getItem("selectedMenu") || selectedMenu)

    const menuMapping = {
      Dashboardpage: { key: "dashboard", title: "Dashboard" },
      Analytics: { key: "Analytics", title: "Analytics" },
      users: { key: "users", title: "User's" },
      payouts: { key: "payouts", title: "Payouts" },
      bbps: { key: "paybills", title: "Pay Bills" },
      PaymentLinks: {
        key: "paymentlinks",
        title: "Payment Links",
      },
      ActiveQR: { key: "activateqr", title: "Active QR" },
      getPaid: { key: "GetPaid", title: "Get Paid" },
      PayService: { key: "MyPayouts", title: "My Payouts" },
      Pos: { key: "Pos", title: "POS" },
      History: { key: "History", title: "History" },
      CreditCardBillPayments: {
        key: "CreditCardbillpayment",
        title: "Credit Card Bill Payment",
      },
      login: {
        key: "Logout",
        title: "Logout",
      },
      Settlement: {
        key: "Settlements",
        title: "Settlements",
      },
      SettlementDetails: {
        key: "Settlements",
        title: "Settlements",
      },
    };

    if (menuMapping[path]) {
      setSelectedMenu(menuMapping[path].key);
      setSelectedMenuTitle(menuMapping[path].title);
      localStorage.setItem("selectedMenu", menuMapping[path].key);
      localStorage.setItem("selectedMenuTitle", menuMapping[path].title);
    }
  }, [location.pathname]);

  const getActiveAppServices = async () => {
    const token = await GetWebAccessToken();
    try {
      const Headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(`${apiUrl}/activeFeatures/get/all`, {
        headers: Headers,
      });

      const features = response.data;
      dispatch(setFeatures(features));
      setActiveFeatures(features);
    } catch (err) {
      console.log("some thing went wrong", err);
    } finally {
      setActiveFeaturesLoading(false);
    }
  };

  useEffect(() => {
    if (isHomeRoute === "/login" || !isAuthenticated) {
      setActiveFeaturesLoading(false);
      return;
    }

    getUserDetails();
    getActiveAppServices();

    const interval = setInterval(() => {
      getActiveAppServices();
    }, 900000);

    return () => clearInterval(interval);
  }, [isAuthenticated, isHomeRoute]);

  const FetchVersionCheck = async () => {
    try {
      const versionResp = await axios.get(`${apiUrl}/merchant/getVersion`);
      if (versionResp?.data?.length > 0) {
        const currentVersion = versionResp.data[0].webAppVersion;
        const versionOfWebApp = localStorage.getItem("appVersion");

        const versionChanged = versionOfWebApp !== currentVersion;

        // Check if web app is disabled in server response
        const isWebAppDisabled = versionResp.data[0].webAppDisabled;

        if (versionChanged) {
          localStorage.setItem("appVersion", currentVersion);
          window.location.reload();
          return true;
        } else {
          localStorage.setItem("appVersion", currentVersion);
        }
      }

      return false; // No update required
    } catch (error) {
      console.error("Error while checking version:", error);
      return false;
    }
  };

  const handleNavigate = async (menu) => {
    const updateRequired = await FetchVersionCheck();

    if (updateRequired) return;
    setSelectedMenu(menu);
    localStorage.setItem("selectedMenu", menu);
    localStorage.removeItem("CONTACT_DETAILS_FLOW");
    dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
    let menuTitle = "";
    switch (menu) {
      case "dashboard":
        menuTitle = "Dashboard";
        navigate("/");
        break;
      case "Analytics":
        menuTitle = "Analytics";
        navigate("/Analytics");
        break;
      case "users":
        menuTitle = "User's";
        navigate("/users");
        break;
      case "FerryBooking":
        menuTitle = "Ferry Booking";
        navigate("/Ferry_LocationSearch");
        break;
      case "payouts":
        menuTitle = "Payouts";
        navigate("/payouts");
        break;
      case "account-details":
        menuTitle = "Account Details";
        navigate("/account-details");
        break;
      case "ProfileDetails":
        menuTitle = "Profile Details";
        // navigate("/ProfileDetails");
        break;
      case "paybills":
        menuTitle = "Pay Bills";
        navigate("/BBPS");
        break;
      case "paymentlinks":
        menuTitle = "Payment Links";
        navigate("/PaymentLinks");
        break;
      case "activateqr":
        menuTitle = "Active QR";
        navigate("/ActiveQR");
        break;
      case "GetPaid":
        menuTitle = "Get Paid";
        navigate("/getPaid");
        break;
      case "MyPayouts":
        menuTitle = "My Payouts";
        navigate("/PayService", {
          state: { previewShow: false, AddingPay: false },
        });
        setMenuKey((prev) => prev + 1);
        break;
      case "ProPartnerAnalytics":
        menuTitle = "ProPartnerAnalytics";
        navigate("/ProPartnerAnalytics");
        break;
      case "ProPartnerUser's":
        menuTitle = "ProPartnerUser's";
        navigate("/ProPartnerUsers");
        break;
      case "ProPartnerPayouts":
        menuTitle = "ProPartnerPayouts";
        navigate("/ProPartnerPayouts");
        break;
      case "History":
        menuTitle = "History";
        navigate("/History");
        break;
      case "Pos":
        menuTitle = "POS";
        navigate("/Pos");
        break;
      case "Payrent":
        menuTitle = "Pay Rent";
        navigate("/PayRent");
        break;
        // case "paymentmethod":
        //   menuTitle = "Payment Method";
        //   navigate("/PaymentMethod");
        break;
      case "User's":
        menuTitle = "User's";
        navigate("/Users");
        break;
      case "Payouts":
        menuTitle = "Payouts";
        navigate("/Payouts");
        break;
      case "AccountDetails":
        menuTitle = "Account Details";
        navigate("/AccountDetails");
        break;

      case "CreditCardbillpayment":
        menuTitle = "Credit Card Bill Payment";
        navigate("/CreditCardBillPayments");
        break;

      case "Settlements":
        menuTitle = "Settlements";
        navigate("/Settlement");
        break;

      case "Logout":
        console.log("logout clicked==>>>");
        console.log("clearing cookies==>>");

        // Clear cookies set by js-cookie
        sessionStorage.clear();
        if (phNo === "9999999999") {
          localStorage.removeItem("dummyUserPhoneNo");
          localStorage.removeItem("tokenDummy");
          localStorage.removeItem("selectedMenu");
          localStorage.removeItem("selectedMenuTitle");
          Cookies.remove("token");
        } else {
          Cookies.remove("token");
          Cookies.remove("MerchantId");
          Cookies.remove("mobileNumber");
          localStorage.removeItem("selectedMenu");
          localStorage.removeItem("selectedMenuTitle");
        }

        menuTitle = "Logout";
        navigate("/login");
        break;

      default:
        break;
    }
    setSelectedMenuTitle(menuTitle);
    localStorage.setItem("selectedMenuTitle", menuTitle);
  };

  useEffect(() => {
    dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
    handleResize();
    setPhNo(localStorage.getItem("dummyUserPhoneNo"));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userDetails) {
      getUserImage();
    }
  }, [userDetails]);

  const getUserImage = async () => {
    const token = await GetWebAccessToken();
    try {
      const userImageRes = await Call_Api(
        path?.GET_USER_IMAGE(userDetails?.MerchantId),
        "GET",
        {},
        token,
      );
      console.log("User image response:", userImageRes);

      const base64Image = userImageRes?.response?.userimage;

      if (
        userImageRes?.success &&
        typeof base64Image === "string" &&
        base64Image.length > 100
      ) {
        setUserImage(base64Image);
      } else {
        setUserImage("");
      }
    } catch (err) {
      console.log("error in getting user image", err);
    }
  };

  const handleMenuClick = ({ key, domEvent }) => {
    setSelectedMenu(key);
    const menuItem = domEvent.target.innerText;
    setSelectedMenuTitle(menuItem);
    if (isMobile) setDrawerVisible(false);
  };

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  const getPathItems = () => {
    if (userDetails?.walletStatus?.toLowerCase() == "active") {
      return [
        "bbps",
        "History",
        "Settlement",
        "PayService",
        "PaymentLinks",
        // "help",
        "getPaid",
        // "support",
        // "ticket",
        // "showTicket",
        "bbps/DTH",
        "bbps/FastTag",
        "bbps/Credit Card",
        "bbps/Loan Repayment",
        "bbps/Insurance",
        "bbps/Municipal Taxes",
        "bbps/Mobile Prepaid",
        // "bbps/Education Fees",
      ];
    } else {
      return [
        "bbps",
        "History",
        "bbps/DTH",
        "bbps/FastTag",
        "bbps/Credit Card",
        "bbps/Loan Repayment",
        "bbps/Insurance",
        "bbps/Municipal Taxes",
        "bbps/Mobile Prepaid",
      ];
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);

    if (query.length > 0) {
      const matches = (getPathItems() || []).filter((item) =>
        item.toLowerCase().includes(query.toLowerCase()),
      );
      setFilteredSuggestions(matches);
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (route) => {
    setSearchText(""); // Clear the search input when a suggestion is clicked
    setFilteredSuggestions([]); // Clear the suggestions
    navigate(`/${route}`); // Navigate to the selected route
  };

  const handleCopy = (copydata) => {
    navigator.clipboard.writeText(copydata || "");
  };

  const menuContent = (
    <Menu
      theme={isDarkMode ? "dark" : "light"}
      mode="inline"
      selectedKeys={[selectedMenu]}
      openKeys={openKeys}
      onOpenChange={handleOpenChange}
      onClick={handleMenuClick}
    >
      <Menu.Item
        onClick={() => handleNavigate("dashboard")}
        key="dashboard"
        icon={
          <GridViewIcon
            className="sidebar-icons-css-demo"
            style={{ fontSize: "1.3rem", color: "var(--lite-gray-two)" }}
          />
        }
      >
        {data?.Dashboard}
      </Menu.Item>

      <Menu>
        <div
          className="menu-side-headings"
          style={{
            color: "var(--lite-gray-two)",
            fontWeight: "500",
            textAlign: "left",
            padding: "10px 16px",
            margin: "0.5rem",
            overflow: "hidden",
            fontSize: "0.8rem",
          }}
        >
          {data?.BILLPAYMENTS}
        </div>
      </Menu>

      <Menu.Item
        onClick={() => handleNavigate("paybills")}
        className="menu-item-soon"
        key="paybills"
        icon={
          <img className="paybills-icon" src={ImagesPath?.Demo?.PayBillIcon} />
        }
      >
        {data?.PayBills}
        <img
          className="bharatpay-demo-v"
          src={ImagesPath?.Demo?.Bharatconnect}
        />
      </Menu.Item>

      {phNo === "9999999999" && (
        <Menu.Item
          onClick={() => handleNavigate("FerryBooking")}
          className="menu-item-soon"
          key="FerryBooking"
          icon={
            <img
              className="paybills-icon"
              src={ImagesPath?.Demo?.PayBillIcon}
            />
          }
        >
          {data?.Ferry}
        </Menu.Item>
      )}

      {isFeatureActive(
        features,
        "Credit_Card_Bill_Payment",
        "Credit_Card_Bill_Payment",
      ) && (
        <Menu.Item
          onClick={() => handleNavigate("CreditCardbillpayment")}
          className="menu-item-soon"
          key="CreditCardbillpayment"
          icon={
            <img className="paybills-icon" src={ImagesPath?.Demo?.CCBillIcon} />
          }
        >
          {data?.creditBill}
        </Menu.Item>
      )}

      {userDetails?.walletStatus?.trim()?.toLowerCase() === "active" &&
        userDetails?.allowWalletSettlements.includes("Settlements") &&
        isFeatureActive(features, "Settlements", "Transfer") && (
          <Menu.Item
            onClick={() => handleNavigate("Settlements")}
            className="menu-item-soon"
            key="Settlements"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.SettlementsIcon}
              />
            }
          >
            {data?.settlements}
          </Menu.Item>
        )}
      <Menu>
        <div
          className="menu-side-headings"
          style={{
            color: "#99A1B7",
            fontWeight: "500",
            textAlign: "left",
            padding: "10px 16px",
            margin: "0.5rem",
            overflow: "hidden",
            fontSize: "0.8rem",
          }}
        >
          {data?.COLLECT}
        </div>
      </Menu>

      {userDetails?.walletStatus?.trim()?.toLowerCase() === "active" &&
        userDetails?.allowWalletSettlements.includes("Settlements") &&
        isFeatureActive(features, "Settlements", "Settlements") && (
          <Menu.Item
            onClick={() => handleNavigate("GetPaid")}
            className="menu-item-soon"
            key="GetPaid"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.GedPaidIcon}
              />
            }
          >
            {data?.gp}
          </Menu.Item>
        )}
      {userDetails?.allowWalletSettlements?.includes("PAYMENT_LINKS") &&
        isFeatureActive(features, "Payment_Links", "Payment_Links") &&
        userDetails?.walletStatus?.toLowerCase() == "active" && (
          <Menu.Item
            onClick={() => handleNavigate("paymentlinks")}
            className="menu-item-soon"
            key="paymentlinks"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.PaymentLinksIcon}
              />
            }
          >
            {data?.payL}
          </Menu.Item>
        )}

      <Menu.Item
        onClick={() => handleNavigate("Pos")}
        className="menu-item-soon"
        key="Pos"
        icon={<img className="paybills-icon" src={ImagesPath?.Demo?.PosIcon} />}
      >
        {data?.pos}
      </Menu.Item>

      <Menu.Item
        onClick={() => handleNavigate("activateqr")}
        className="menu-item-soon"
        key="activateqr"
        icon={<img className="paybills-icon" src={ImagesPath?.Demo?.QrIcon} />}
      >
        {data?.ActiveQR}
      </Menu.Item>

      {userDetails?.walletStatus?.trim()?.toLowerCase() === "active" &&
        userDetails?.allowWalletSettlements.includes("PayOut_Settlements") &&
        isFeatureActive(
          features,
          "PayOut_Settlements",
          "PayOut_Settlements",
        ) && (
          <Menu>
            <div
              className="menu-side-headings"
              style={{
                color: "#99A1B7",
                fontWeight: "500",
                textAlign: "left",
                padding: "10px 16px",
                margin: "0.5rem",
                overflow: "hidden",
              }}
            >
              {data?.PAYOUTS}
            </div>
          </Menu>
        )}

      {userDetails?.walletStatus?.trim()?.toLowerCase() === "active" &&
        userDetails?.allowWalletSettlements.includes("PayOut_Settlements") &&
        isFeatureActive(
          features,
          "PayOut_Settlements",
          "PayOut_Settlements",
        ) && (
          <Menu.Item
            onClick={() => handleNavigate("MyPayouts")}
            className="menu-item-soon"
            key="MyPayouts"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.PayBillIcon}
              />
            }
          >
            {data?.Pay}
          </Menu.Item>
        )}

      {/* <Menu.Item
        onClick={() => handleNavigate("History")}
        className="menu-item-soon"
        key="History"
        icon={<CircleIcon style={{ fontSize: "1.8rem", color: "var(--gray-three)" }} />}
      >
        My Payouts
      </Menu.Item> */}

      {userDetails?.allowPartnerStatus?.toLowerCase() === "active" &&
        userDetails?.walletStatus?.toLowerCase() == "active" &&
        userDetails?.walletStatus && (
          <Menu>
            <div
              className="menu-side-headings"
              style={{
                color: "var(--lite-gray-two)",
                fontWeight: "500",
                textAlign: "left",
                padding: "10px 16px",
                margin: "0.5rem",
                overflow: "hidden",
                fontSize: "0.8rem",
              }}
            >
              {data?.PARTNER}
            </div>
          </Menu>
        )}

      {userDetails?.allowPartnerStatus?.toLowerCase() === "active" &&
        userDetails?.walletStatus?.toLowerCase() == "active" &&
        userDetails?.walletStatus && (
          <Menu.SubMenu
            key="Partner"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.PartnerIcon}
              />
            }
            title="Partner"
            expandIcon={({ isOpen }) =>
              isOpen ? (
                <span
                  style={{ fontSize: "1.2rem", color: "var(--gray-three)" }}
                >
                  -
                </span>
              ) : (
                <span
                  style={{ fontSize: "1.2rem", color: "var(--gray-three)" }}
                >
                  +
                </span>
              )
            }
          >
            <Menu
              theme="light"
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={handleMenuClick}
            >
              <Menu.Item
                onClick={() => handleNavigate("Analytics")}
                key="Analytics"
              >
                {data?.Analytics}
              </Menu.Item>
              <Menu.Item onClick={() => handleNavigate("User's")} key="User's">
                {data?.user}
              </Menu.Item>
              <Menu.Item
                onClick={() => handleNavigate("Payouts")}
                key="Payouts"
              >
                {data?.payout}
              </Menu.Item>
              <Menu.Item
                onClick={() => handleNavigate("AccountDetails")}
                key="AccountDetails"
              >
                {data?.account}
              </Menu.Item>
            </Menu>
          </Menu.SubMenu>
        )}

      {userDetails?.propartnerStatus?.toLowerCase() === "active" &&
        userDetails?.walletStatus?.toLowerCase() == "active" && (
          <Menu.SubMenu
            key="Pro-Partner"
            icon={
              <img
                className="paybills-icon"
                src={ImagesPath?.Demo?.PartnerIcon}
              />
            }
            title="Pro-Partner"
            expandIcon={({ isOpen }) =>
              isOpen ? (
                <span
                  style={{ fontSize: "1.2rem", color: "var(--gray-three)" }}
                >
                  -
                </span>
              ) : (
                <span
                  style={{ fontSize: "1.2rem", color: "var(--gray-three)" }}
                >
                  +
                </span>
              )
            }
          >
            <Menu
              theme="light"
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={handleMenuClick}
            >
              <Menu.Item
                onClick={() => handleNavigate("ProPartnerAnalytics")}
                key="Analytics"
              >
                {data?.Analytics}
              </Menu.Item>
              <Menu.Item
                onClick={() => handleNavigate("ProPartnerUser's")}
                key="User's"
              >
                {data?.user}
              </Menu.Item>
              <Menu.Item
                onClick={() => handleNavigate("ProPartnerPayouts")}
                key="Payouts"
              >
                {data?.payout}
              </Menu.Item>
              <Menu.Item
                onClick={() => handleNavigate("AccountDetails")}
                key="AccountDetails"
              >
                {data?.account}
              </Menu.Item>
            </Menu>
          </Menu.SubMenu>
        )}

      <Menu.Item
        className="menu-item-soon"
        key=" Referral"
        icon={
          <img className="paybills-icon" src={ImagesPath?.Demo?.ReferralIcon} />
        }
      >
        {data?.Referral}
      </Menu.Item>

      <Menu.Item
        onClick={() => handleNavigate("History")}
        className="menu-item-soon"
        key="History"
        icon={
          <img
            className="paybills-icon"
            src={ImagesPath?.Demo?.TransactionsIcon}
          />
        }
      >
        {data?.Transactions}
      </Menu.Item>

      <Menu.Item
        className="menu-item-soon"
        key="Help"
        icon={
          <img className="paybills-icon" src={ImagesPath?.Demo?.HelpIcon} />
        }
      >
        {data?.Help}
      </Menu.Item>

      <Popconfirm
        title="Logging Out"
        description="Are you sure Want to Logout ?"
        icon={
          <QuestionCircleOutlined
            style={{ color: "var(--red)", fontSize: "1rem" }}
          />
        }
        onConfirm={() => handleNavigate("Logout")}
        okText="Yes"
        cancelText="No"
      >
        <Menu.Item
          className="menu-item-logout"
          key="Logout"
          icon={
            <img className="paybills-icon" src={ImagesPath?.Demo?.LogoutIcon} />
          }
          sx={{ color: "red" }}
        >
          {data?.lg}
        </Menu.Item>
      </Popconfirm>
    </Menu>
  );

  return (
    <>
      {activeFeaturesLoading ? (
        <Loaders />
      ) : (
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "'SF Pro Display', sans-serif",
            },
            algorithm: isDarkMode
              ? theme.darkAlgorithm
              : theme.defaultAlgorithm,
          }}
        >
          <Layout>
            {!isMobile && (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                theme={isDarkMode ? "dark" : "light"}
                width={240}
              >
                <div className="demo-logo-vertical" />
                <div className="logo-side-fulldiv">
                  <img
                    className="logo-sidebar-ntar"
                    src={ImagesPath?.Demo?.ntarbizzlogo}
                    alt="Logo"
                  />
                </div>
                {menuContent}
              </Sider>
            )}

            <Layout>
              <Header
                style={{
                  padding: 0,
                  background: isDarkMode ? "#001529" : "#fff",
                }}
              >
                <div className="header-div">
                  <div className="menu-selected">
                    {isMobile && (
                      <Button
                        type="text"
                        icon={
                          <img
                            src={ImagesPath?.Demo?.sidemenuicon}
                            alt="Menu Icon"
                            className="menu-icon-side"
                            style={{ width: "80px", height: "80px" }}
                          />
                        }
                        onClick={() => setDrawerVisible(true)}
                        style={{
                          fontSize: "16px",
                          width: 64,
                          height: 64,
                          display: "flex",
                          color: isDarkMode ? "#fff" : "var(--black)",
                        }}
                      />
                    )}
                    {!isMobile && (
                      <Button
                        type="text"
                        icon={
                          <img
                            src={ImagesPath?.Demo?.sidemenuicon}
                            alt="Menu Icon"
                            className="menu-icon-side"
                            style={{ width: "80px", height: "80px" }}
                          />
                        }
                        onClick={toggleCollapsed}
                        style={{
                          fontSize: "16px",
                          width: 64,
                          height: 64,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: isDarkMode ? "#fff" : "var(--black)",
                        }}
                      />
                    )}
                    {/* <div>
                  <p className="selecteditem-demo">{selectedMenuTitle}</p>{" "}
                </div> */}
                  </div>
                  {isMobile && (
                    <>
                      {/* <Input.Search
                    className="search-header-bbpsservice"
                    placeholder="Search here"
                  /> */}
                      <div className="search-container">
                        <SearchIcon
                          style={{ color: "var(--thirdshade-orange)" }}
                          className="search-icon"
                        />
                        <input
                          type="text"
                          placeholder="Search by Name or Amount"
                          className="search-demo"
                          onChange={handleSearch}
                          value={searchQuery}
                        />
                      </div>
                      <Button
                        type="text"
                        icon={<MenuUnfoldOutlined />}
                        onClick={() => setShowSearchProfile(!showSearchProfile)}
                        style={{
                          fontSize: "24px",
                          width: 64,
                          height: 64,
                          display: "flex",
                          color: isDarkMode ? "#fff" : "var(--black)",
                        }}
                      />
                    </>
                  )}
                  {!isMobile && (
                    <div className="search-to-last-demo">
                      <div className="search-container">
                        <SearchIcon
                          style={{ color: "var(--thirdshade-orange)" }}
                          className="search-icon"
                        />
                        <input
                          type="text"
                          placeholder="Search here"
                          className="search-demo"
                          onChange={handleSearchChange}
                          value={searchText}
                          style={{ border: "1.5px solid #64B5F6" }}
                        />
                        {filteredSuggestions.length > 0 && (
                          <ui
                            className="list-group suggestions-dropdown"
                            style={{
                              height: "200px",
                              width: "230px",
                              position: "absolute",
                              zIndex: 99,
                            }}
                          >
                            {filteredSuggestions.map((item, index) => (
                              <span
                                key={index}
                                className="list-group-item list-group-item-action btn fs-5"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSuggestionClick(item)}
                              >
                                {item}
                              </span>
                            ))}
                          </ui>
                        )}
                      </div>

                      <div className="plus-div-demo">
                        <img
                          className="plus"
                          src={ImagesPath?.Demo?.Plus}
                          alt="Logo"
                        />
                      </div>
                      {userDetails?.walletStatus?.toLowerCase() == "active" && (
                        <div className="totalamount-demo">
                          <img
                            className="bizz-coin"
                            src={ImagesPath?.Demo?.ntarbizzcoin}
                            alt="Logo"
                          />
                          <p style={{ margin: "0px" }}>
                            {Math.floor(userDetails?.walletBalance)}
                          </p>
                        </div>
                      )}
                      <div className="small-vertical-line"></div>
                      <div
                        className="profile-div"
                        // onClick={() => handleNavigate("ProfileDetails")}
                      >
                        <img
                          className="bizz-profile"
                          src={
                            userDetails?.userimage !== "true" &&
                            typeof userDetails?.userimage === "string"
                              ? `data:image/png;base64,${userDetails?.userimage}`
                              : userImage
                                ? `data:image/png;base64,${userImage}`
                                : ImagesPath?.Demo?.Profile
                          }
                          alt="Logo"
                        />
                        <div className="span-text-div">
                          <span className="profile-name">{userName}</span>
                          <span className="merchant-id">
                            {data?.mID} {userDetails?.MerchantId}
                            <ContentCopyIcon
                              style={{ fontSize: "0.7rem", marginLeft: "2px" }}
                              onClick={() =>
                                handleCopy(userDetails?.MerchantId)
                              }
                            />
                          </span>
                        </div>
                      </div>
                      <div className="small-vertical-line"></div>
                      <QuestionCircleOutlined className="help-icon" />
                    </div>
                  )}
                </div>
              </Header>

              <Content
                className="content-height"
                style={{
                  background: isDarkMode ? "#141414" : "#f5f5f5",
                  color: isDarkMode ? "#fff" : "var(--black)",
                  minHeight: "100vh",
                  height: "100vh",
                  // overflowY:'scroll'
                }}
              >
                {/* {renderContent()} */}
                <Outlet></Outlet>
              </Content>
              {/* <Footer /> */}
              <div>
                {children}
                {!hiddenFooterPaths.includes(location.pathname) && <Footer />}
              </div>
            </Layout>
          </Layout>

          {isMobile && (
            <Drawer
              title="Menu"
              placement="left"
              closable={true}
              onClose={() => setDrawerVisible(false)}
              visible={drawerVisible}
              bodyStyle={{ padding: 0 }}
            >
              {menuContent}
            </Drawer>
          )}

          {isMobile && showSearchProfile && (
            <Drawer
              title="Search & Profile"
              placement="right"
              closable={true}
              onClose={() => setShowSearchProfile(false)}
              visible={showSearchProfile}
              bodyStyle={{ padding: 0 }}
            >
              <div className="search-to-last-demo">
                <div className="rupee-coin-div-mobile">
                  <div className="plus-div-demo">
                    <img
                      className="plus"
                      src={ImagesPath?.Demo?.Plus}
                      alt="Logo"
                    />
                  </div>
                  <div className="totalamount-demo">
                    <img
                      className="bizz-coin"
                      src={ImagesPath?.Demo?.ntarbizzcoin}
                      alt="Logo"
                    />
                    <p style={{ margin: "0px" }}>
                      {Math.floor(userDetails?.walletBalance)}
                    </p>
                  </div>
                  {/* <div className="small-vertical-line"></div> */}
                </div>
                <div
                  // onClick={() => handleNavigate("ProfileDetails")}
                  className="profile-div"
                >
                  <div className="profile-help-mobile">
                    <img
                      className="bizz-profile"
                      src={ImagesPath?.Demo?.Profile}
                      alt="Logo"
                    />
                    <div className="span-text-div">
                      <span className="profile-name">
                        {userDetails?.userName}
                      </span>
                      <span className="merchant-id">
                        {data?.mID} {userDetails?.MerchantId}
                        <ContentCopyIcon
                          style={{ fontSize: "0.7rem", marginLeft: "2px" }}
                          onClick={() => handleCopy(userDetails?.MerchantId)}
                        />
                      </span>
                    </div>
                  </div>
                  <QuestionCircleOutlined className="help-icon" />
                </div>
              </div>
            </Drawer>
          )}
        </ConfigProvider>
      )}
    </>
  );
};

export default Demo;
